<template>
  <font-awesome-icon
    :icon="'spinner'"
    spin
    class="destaque-header"
    v-if="isLoading"
  />
  <span class="destaque-header" v-else>
    {{ value }}
  </span>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: true
    }
  }
}
</script>

<style scoped>
.destaque-header {
  color: #f0f8ff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ValorDestaqueHeader.vue